import { useBackend } from "../../services";

export const useGetDiscogsImportStatus = () => {
  const { get } = useBackend();
  return async () => {
    return await get("discogs/import");
  };
};
